import Resource from './Resource';
import SimpleResource from './SimpleResource';
export * from './types';
export * from './normal';
var SuperagentResource = Resource;
export { Resource, SimpleResource, SuperagentResource };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZXNvdXJjZS9pbmRleC50cyJdLCJuYW1lcyI6WyJSZXNvdXJjZSIsIlNpbXBsZVJlc291cmNlIiwiU3VwZXJhZ2VudFJlc291cmNlIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxRQUFQLE1BQXFCLFlBQXJCO0FBQ0EsT0FBT0MsY0FBUCxNQUEyQixrQkFBM0I7QUFDQSxjQUFjLFNBQWQ7QUFDQSxjQUFjLFVBQWQ7QUFFQSxJQUFNQyxrQkFBa0IsR0FBR0YsUUFBM0I7QUFFQSxTQUFTQSxRQUFULEVBQW1CQyxjQUFuQixFQUFtQ0Msa0JBQW5DIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlc291cmNlIGZyb20gJy4vUmVzb3VyY2UnO1xuaW1wb3J0IFNpbXBsZVJlc291cmNlIGZyb20gJy4vU2ltcGxlUmVzb3VyY2UnO1xuZXhwb3J0ICogZnJvbSAnLi90eXBlcyc7XG5leHBvcnQgKiBmcm9tICcuL25vcm1hbCc7XG5cbmNvbnN0IFN1cGVyYWdlbnRSZXNvdXJjZSA9IFJlc291cmNlO1xuXG5leHBvcnQgeyBSZXNvdXJjZSwgU2ltcGxlUmVzb3VyY2UsIFN1cGVyYWdlbnRSZXNvdXJjZSB9O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/rest-hooks/lib/resource/index.js
// module id = null
// module chunks = 